export default "__VITE_ASSET__CpzmzE6u__"